import React, { useEffect } from 'react';
import Banner from "./Banner"

import '../ProductsLanding/styles/01_banner.css';
import OurServicesAccordion from './OurServicesAccordion';
import ContactForms from './ContactForms';
import RelatedProducts from '../../Molecules/RelatedProduct/RelatedProducts';

export default function Controlers() {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <Banner />

      <OurServicesAccordion />

      <RelatedProducts  title="Related Products"/>
      <ContactForms className="true"/>    
    </>
  );
}
